import React from 'react';
import {init} from 'ityped';
import {useEffect , useRef} from "react";
import Kanchanaburi from "../../../assets/Kanchanaburi.jpg"
import "./Hero.css";
import EmailIcon from '@mui/icons-material/Email';
import Button from '@mui/material/Button';


function Hero() {
    const textRef = useRef();
useEffect(()=>{
    init(textRef.current,{showCursor: false, strings:[' Web Developer ' , ' Computer Teacher ', ' Mathematics Teacher']})
},[])

    
    return (
        <div className="gridContainerHero">
            <div> <img src={Kanchanaburi} alt="KNC"></img></div>

            
            <div className="heroHeading">
            <h1> Hey there, I'm Saurabh Prasad Jaiswal My nick name is Jazzy and I'm <br/><span ref = {textRef}> </span></h1>
            <a href="mailto:saurabhjaiswaljazzy@gmail.com"><Button variant="contained">Lets Talk !<EmailIcon fontSize="large"/></Button></a>
            </div>
        </div>
    )
} 

export default Hero;

